<template>
  <div>
    <template v-if="!nucleusUser()">
      <h1 class="page-header">No Access</h1>
      You do not have access to the document manager. Please contact HIA.
    </template>
    <template v-else>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <clientNavSelector></clientNavSelector>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: `/${currentClientId}/documents` }">Document Manager</el-breadcrumb-item>
      <el-breadcrumb-item v-for="breadcrumb in fileBreadCrumbs" :to="breadcrumb.to" :key="breadcrumb.to.path"> {{ breadcrumb.label }}</el-breadcrumb-item>
    </el-breadcrumb>
    <hia-loading v-if="loading"></hia-loading>
    <el-row v-if="!loading" style="margin-top: -20px;">
      <a id="hiddenAnchor" style="display: none;"></a>
      <el-col :span="20" style=" margin-bottom: 50px;">
        <div style="float: right; margin: 27px 0px 10px 0px;">
          <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria"> </el-input>
        </div>
        <el-table ref="documentTable" id="documentTable" :data="filteredDocuments" @selection-change="handleSelectionChange" :height="filteredDocuments.length > 8 ? '55vh' : 'auto'">
          <el-table-column type="selection" width="35"> </el-table-column>
          <el-table-column sortable prop="name" label="Name" min-width="200" class-name="document-item">
            <template slot-scope="scope">
              <div v-if="scope.row.isFolder" class="item">
                <el-row :span="24" :gutter="10">
                  <!-- <el-col :span="2">
                    <i @click="navigateToFolder(scope.row.name)" class="mdi mdi-folder folderIcon"></i>
                  </el-col>
                  <el-col :span="22">
                    <span v-if="showFileFolderNameInput !== scope.row.id" @click="navigateToFolder(scope.row.name)"
                      class="docName">{{scope.row.name}}</span>
                    <el-input v-if="showFileFolderNameInput === scope.row.id"
                      :class="'documentTableInput_'+scope.row.id" placeholder="Please input" v-model="newFileFolderName"
                      @blur="putEditFileFolderName(scope.row)">
                    </el-input>
                  </el-col> -->
                  <el-col :span="24" class="ieGridFix" style="display: grid; grid-template-columns: 36px auto;">
                    <i @click="navigateToFolder(scope.row.name)" class="mdi mdi-folder folderIcon"></i>
                    <span style="grid-column: 2; margin-left: 5px;" v-if="showFileFolderNameInput !== scope.row.id" @click="navigateToFolder(scope.row.name)" class="ieGridColumnFix docName" v-html="highlightValue(scope.row.name, filterCriteria)"></span>
                    <el-input class="renameInput" style="grid-column: 2; margin: 0px 0px 0px 5px;" v-if="showFileFolderNameInput === scope.row.id" :class="'ieGridColumnFix documentTableInput_' + scope.row.id" placeholder="Please input" v-model="newFileFolderName" @blur="putEditFileFolderName(scope.row)"> </el-input>
                  </el-col>
                </el-row>
              </div>
              <div v-else class="item">
                <el-row :span="24">
                  <!-- <el-col :span="2">
                    <i @click="getDownloadLink(scope.row.id)"
                      :class="'mdi '+handleExtensionIcon(scope.row.name)+' docIcon'"></i>
                  </el-col>
                  <el-col :span="22">
                    <span v-if="showFileFolderNameInput!== scope.row.id"
                      @click="getDownloadLink(scope.row.id)">{{scope.row.name}}</span>
                    <el-input v-if="showFileFolderNameInput === scope.row.id"
                      :class="'documentTableInput_'+scope.row.id" placeholder="Please input" v-model="newFileFolderName"
                      @blur="putEditFileFolderName(scope.row)">
                    </el-input>
                  </el-col> -->
                  <el-col :span="24" class="ieGridFix" style="display: grid; grid-template-columns: 36px auto;">
                    <i @click="getDownloadLink(scope.row.id)" :class="'mdi ' + handleExtensionIcon(scope.row.name) + ' docIcon'"></i>
                    <span class="ieGridColumnFix docName" style="grid-column: 2; margin-left: 5px;" v-if="showFileFolderNameInput !== scope.row.id" @click="getDownloadLink(scope.row.id)" v-html="highlightValue(scope.row.name, filterCriteria)"></span>
                    <el-input v-if="showFileFolderNameInput === scope.row.id" :class="'ieGridColumnFix documentTableInput_' + scope.row.id" placeholder="Please input" v-model="newFileFolderName" @blur="putEditFileFolderName(scope.row)" style="grid-column: 2; margin: 0px 0px 0px 5px;"> </el-input>
                  </el-col>
                </el-row>
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable prop="created" label="Created">
            <template slot-scope="scope">
              <div v-html="highlightValue(formatDate(scope.row.created), filterCriteria)"></div>
            </template>
          </el-table-column>
          <el-table-column sortable prop="creatorName" label="Creator">
            <template slot-scope="scope">
              <div v-html="highlightValue(scope.row.creatorName, filterCriteria)"></div>
            </template>
          </el-table-column>
          <el-table-column label="Download Count" prop="documentDownloads" sortable>
            <template slot-scope="scope">
              <span v-if="!scope.row.isFolder">
                {{ scope.row.documentDownloads.length }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="" width="40">
            <template slot-scope="scope">
              <el-dropdown style="float: left;" trigger="click" @command="actionMenuCommands" size="medium">
                <span class="el-dropdown-link">
                  <i class="mdi mdi-dots-horizontal ellipsesIcon"></i>
                </span>
                <el-dropdown-menu slot="dropdown" style="width: 150px;" class="documentActionMenu">
                  <el-dropdown-item :command="{ scope: scope, action: 'download' }"><i class="mdi mdi-file-download-outline documentActionMenuIcon"></i>Download </el-dropdown-item>
                  <el-dropdown-item :command="{ scope: scope, action: 'move' }" v-if="!scope.row.isFolder"><i class="mdi mdi-file-replace-outline documentActionMenuIcon" v-if="!scope.row.isFolder"></i>Move </el-dropdown-item>
                  <el-dropdown-item :command="{ scope: scope, action: 'copy' }" v-if="!scope.row.isFolder"><i class="mdi mdi-file-replace-outline documentActionMenuIcon" v-if="!scope.row.isFolder"></i>Copy </el-dropdown-item>
                  <el-dropdown-item :command="{ scope: scope, action: 'rename' }"><i class="mdi mdi-cursor-text documentActionMenuIcon"></i>Rename</el-dropdown-item>
                  <el-dropdown-item :command="{ scope: scope, action: 'delete' }"><i class="mdi mdi-delete-outline documentActionMenuIcon"></i>Delete</el-dropdown-item>
                  <el-dropdown-item divided v-if="!scope.row.isFolder" command="downloadHistory">
                    <el-popover transition="" placement="bottom" title="Download History" width="400" trigger="hover">
                      <!-- <i v-if="!scope.row.isFolder" slot="reference" class="el-icon-more"></i> -->
                      <span slot="reference">{{ scope.row.documentDownloads.length }} Downloads</span>
                      <el-table v-if="scope.row.documentDownloads.length > 0" :data="scope.row.documentDownloads">
                        <el-table-column prop="email"> </el-table-column>
                        <el-table-column prop="downloadDate">
                          <template slot-scope="scope">
                            {{ formatDate(scope.row.downloadDate) }}
                          </template>
                        </el-table-column>
                      </el-table>
                      <span v-else>None</span>
                    </el-popover>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <template slot="empty">
            <p>{{ deletedDirectoryMessage ? deletedDirectoryMessage : `No Documents Available` }}</p>
          </template>
        </el-table>
        <div id="documentTableStats">
          <p>{{ documentTableStats() }}</p>
        </div>
      </el-col>
      <el-col :span="4" style="margin-top: 10px;">
        <ul class="actionButtons" v-if="!deletedDirectoryMessage">
          <li @click="openUploadDialog">
            <div class="actionButtonsItemActive">
              <i style="font-size: 18px;" class="mdi mdi-file-upload-outline actionButtonsIcon"></i>
              Upload Files
            </div>
            <input id="fileUpload" style="display: none;" name="txttoImport" type="file" @change="handleFileUpload" multiple />
          </li>
          <li v-if="documentAdmin()" @click="newFolderDialogVisible = true">
            <div class="actionButtonsItem">
              <span><i class="mdi mdi-folder-plus-outline actionButtonsIcon"></i> New Folder</span>
            </div>
          </li>
          <li v-if="selectedRows.length > 0" @click="openDownloadDialog(selectedRows)">
            <div class="actionButtonsItem">
              <span><i class="mdi mdi-file-download-outline actionButtonsIcon"></i> Download</span>
            </div>
          </li>
          <li v-if="documentAdmin() && selectedRows.filter(x => !x.isFolder).length > 0" @click="openMoveDialog(false)">
            <div class="actionButtonsItem">
              <span><i class="mdi mdi-file-replace-outline actionButtonsIcon"></i> Move</span>
            </div>
          </li>
          <li v-if="documentAdmin() && selectedRows.filter(x => !x.isFolder).length > 0" @click="openMoveDialog(true)">
            <div class="actionButtonsItem">
              <span><i class="mdi mdi-file-replace-outline actionButtonsIcon"></i> Copy</span>
            </div>
          </li>
          <li v-if="documentAdmin() && selectedRows.length === 1" @click="editFileFolderName(0, selectedRows[0])">
            <div class="actionButtonsItem">
              <span><i class="mdi mdi-cursor-text actionButtonsIcon"></i> Rename</span>
            </div>
          </li>
          <li v-if="selectedRows.length > 0" @click="deleteSelected">
            <div class="actionButtonsItem">
              <span><i class="mdi mdi-delete-outline actionButtonsIcon"></i> Delete</span>
            </div>
          </li>
          <li v-if="documentManagerAdmin() && selectedRows.filter(x => !x.isFolder).length > 0" :class="!itemId ? 'itemDisabled' : ''" :title="!itemId ? 'Sharepoint Library not Linked.  Please link via the Particle Clients section.' : ''">
            <div @click="openMoveParticleDialog" class="actionButtonsItem" style="font-size: 14px;">
              <span><i class="mdi mdi-file-replace-outline actionButtonsIcon"></i> Move to Particle</span>
            </div>
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-dialog title="Create New Folder" :visible.sync="newFolderDialogVisible" width="50%" :before-close="closeNewFolderDialog">
      <el-form label-position="top" @submit.prevent.native>
        <el-form-item label="New Folder Name">
          <el-input type="text" v-model="newFolderName" maxlength="100"> </el-input>
          <span
            ><small style="position: absolute; bottom: -30px; left: 0px;">{{ invalidFolderMessage() }}</small></span
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeNewFolderDialog">Cancel</el-button>
        <el-button :disabled="newFolderName && invalidFolderMessage().length > 0" type="primary" @click="createNewFolder">Create Folder</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="moveMessage" :visible.sync="moveDialogVisible" width="50%" :before-close="closeMoveDialog">
      <div class="document-item">
        <span @click="moveActionDrilldown({ name: '', directory: '' }, true)" class="item">Document Manager </span>
        <template v-if="moveToBreadcrumbs.length > 0">
          >
        </template>
        <span v-for="(breadcrumb, i) in moveToBreadcrumbs" :key="breadcrumb.name">
          <span @click="moveActionDrilldown(breadcrumb, true)" class="item">
            {{ breadcrumb.name }}
          </span>
          <template v-if="i + 1 !== moveToBreadcrumbs.length">
            >
          </template>
        </span>
      </div>
      <div style="min-height: 200px; padding: 0;">
        <el-table v-if="!moveDialogLoading" :data="moveActionSubdirectories" style="width: 100%" :highlight-current-row="true">
          <el-table-column prop="name" label="" min-width="200" class-name="document-item">
            <template slot-scope="scope">
              <el-col :span="1">
                <i class="mdi mdi-folder folderIcon"></i>
              </el-col>
              <el-col :span="23">
                <div class="item" @click="moveActionDrilldown(scope.row)">
                  <span style="margin: 3px 0px 0px 10px;float: left;">{{ scope.row.name }}</span>
                  <i style="font-size: 18px; float: right; margin-top: 4px;" v-if="scope.row.hasSubdirectories" class="mdi mdi-chevron-right"></i>
                </div>
              </el-col>
            </template>
          </el-table-column>
          <template slot="empty">
            <p>No Documents Available</p>
          </template>
        </el-table>
        <hia-loading v-if="moveDialogLoading"></hia-loading>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeMoveDialog">Cancel</el-button>
        <el-button :disabled="isMoveDisabled()" type="primary" @click="moveSelected">{{ copyFiles ? 'Copy' : 'Move' }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="fileOperationsDialogTitle" :visible.sync="fileOperationsDialogVisible" width="50%" :before-close="closeFileOperationsDialog" :close-on-click-modal="false" @closed="handleFileOperationsDialogClosed">
      <div style="display: flex; align-items: center;">
        <div style="margin-right: 10px;" v-if="!fileOpeartionConfirmed">{{ fileOperationsConfirmMessage }}</div>
        <template v-if="fileOperationsConfirmMessage && !fileOpeartionConfirmed && hasFileNameException()">
          <div style="margin-left: auto;"></div>
          <div style="flex-basis: 200px; flex-grow: 0; flex-shrink: 0;"><el-input v-model="massUpdateFileReason" style="width: 200px;" maxlength="500" placeholder="Mass Update Exceptions" @input="handleMassUpdateFileReason"></el-input></div>
          <div v-if="getExceptionLength() > 0" class="dot" style="flex-basis: 18px; flex-grow: 0; flex-shrink: 0;">
            <div>
              {{ getExceptionLength() }}
            </div>
          </div>
          <div v-if="getExceptionLength() === 0">
            <i style="color: green; font-weight: bold; font-size: 18px; margin-left: 5px; margin-right: 15px;" class="el-icon-check"></i>
          </div>
        </template>
      </div>

      <el-table id="fileOperationDialogTable" ref="fileOperationDialogTable" :data="filesToOperateOn" style="width: 100%; margin-top: 20px;">
        <el-table-column prop="name" label="" min-width="200" class-name="document-item"> </el-table-column>
        <el-table-column label="" min-width="130">
          <template slot-scope="scope">
            <div id="test" style="display: flex; align-items: center;">
              <div>{{ scope.row.statusMessage }}</div>
              <div style="margin-left: auto;">
                <el-progress style="float: right;" v-if="(fileOperationsConfirmMessage && fileOpeartionConfirmed) || !fileOperationsConfirmMessage" type="circle" :percentage="scope.row.percentCompleted" :status="scope.row.progressStatus" :width="45" :color="scope.row.progressColor">
                  {{ scope.row.progressStatus === 'text' ? `${scope.row.percentCompleted}%` : '' }}
                </el-progress>
              </div>
              <template v-if="fileOperationsConfirmMessage && !fileOpeartionConfirmed && isHIAUser()">
                <div style="">
                  <div style="display: flex; align-items: center;">
                    <div>
                      <el-input v-if="!validateFileNameClient(scope.row.name)" style="width: 200px;" maxlength="500" v-model="scope.row.fileNameExceptionReason" placeholder="File Name Exception Reason"></el-input>
                    </div>
                    <div>
                      <i v-if="!validateFileNameClient(scope.row.name) && !scope.row.fileNameExceptionReason" style="color: red; font-weight: bold; font-size: 18px; margin-left: 5px; margin-right: 5px; margin-top: 2px;" class="el-icon-error" title="The file is not for this client"></i>
                      <i style="color: green; font-weight: bold; font-size: 18px; margin-left: 5px; margin-right: 5px; margin-top: 2px;" v-if="validateFileNameClient(scope.row.name) || scope.row.fileNameExceptionReason" class="el-icon-check" title="The file name is for this client or an exception reason has been provided"></i>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <p>No Documents Available</p>
        </template>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="disableConfirm()" :title="disableConfirm() ? 'Enter File Name Exception Reason before continuing' : 'Confirm'" v-if="fileOperationsConfirmMessage && !fileOpeartionConfirmed" type="primary" @click="startFileUpload">Confirm</el-button>
        <el-button v-if="fileOperationsConfirmMessage && !fileOpeartionConfirmed" @click="closeFileOperationsDialog">Cancel</el-button>
        <el-button v-if="!fileOperationsConfirmMessage || fileOpeartionConfirmed" @click="closeFileOperationsDialog">Close</el-button>
      </span>
    </el-dialog>
    <div v-if="documentManagerAdmin()">
      <onedriveList ref="onedriveListChild" v-show="false" v-if="oneDriveWait" :listId="listId" :listName="listName" :itemId="itemId"> </onedriveList>
    </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { format, parseISO } from 'date-fns'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import { Message } from 'element-ui'
import hiaFilters from '@/mixins/hiaFilters'
import onedriveList from '@/components/onedrive/onedriveList'

export default {
  name: 'documentManager',
  mixins: [HiaAuthorization, hiaFilters],
  data() {
    return {
      deletedDirectoryMessage: '',
      massUpdateFileReason: null,
      fileBreadCrumbs: [],
      loading: true,
      parentDirectoryNavigation: '/',
      filesToOperateOn: [],
      newFolderDialogVisible: false,
      moveDialogVisible: false,
      moveDialogLoading: false,
      moveMessage: '',
      moveToDirectory: null,
      moveToBreadcrumbs: [],
      copyFiles: false,
      fileOperationsDialogVisible: false,
      fileOperationsDialogTitle: '',
      fileOperationsConfirmMessage: '',
      fileOpeartionConfirmed: false,
      newFolderName: '',
      selectedRows: [],
      zipFile: {},
      newFileFolderName: '',
      showFileFolderNameInput: 0,
      filterCriteria: '',
      listId: 'b!jD67Yp40tESxlvmv11jQY9vg8CcxHdZDjIu1Q_VbYwml55FuDYjiSKVSWeu7ALVg',
      listName: 'Coding and Review Policies',
      itemId: '',
      oneDriveWait: false
    }
  },
  components: {
    onedriveList
  },
  methods: {
    ...mapActions(['showErrorMessage', 'showSuccessMessage']),
    ...mapActions('documents', ['GET_DOCUMENTS', 'GET_DOWNLOAD_LINK', 'POST_DOCUMENT', 'POST_FOLDER', 'DELETE_DOCUMENT', 'GET_SUBDIRECTORIES', 'MOVE_DOCUMENT', 'COPY_DOCUMENT', 'DOWNLOAD_MULTIPLE', 'PUT_RENAMEDOCUMENT', 'POST_ZIPBUILDER']),
    ...mapActions('emailAlerts', ['POST_DOCUPLOADALERT']),
    initialize() {
      if (!this.nucleusUser()) {
        this.loading = false
        return
      }
      if (this.$route.hash) {
        this.parentDirectoryNavigation = this.$route.hash.replace('#', '')
      } else {
        this.parentDirectoryNavigation = '/'
      }
      this.setFileBreadCrumbs(this.parentDirectoryNavigation)
      this.loading = true
      this.GET_DOCUMENTS(this.parentDirectoryNavigation)
        .then(() => {
          this.deletedDirectoryMessage = ''
          this.loading = false
        })
        .catch(error => {
          console.log(error.response.data.message)
          this.deletedDirectoryMessage = error.response.data.message
          this.loading = false
        })
    },
    handleMassUpdateFileReason() {
      this.filesToOperateOn = this.filesToOperateOn.map(x => {
        if (!this.validateFileNameClient(x.name)) {
          x.fileNameExceptionReason = this.massUpdateFileReason
        }
        return x
      })
    },
    getExceptionLength() {
      return this.filesToOperateOn.filter(x => !this.validateFileNameClient(x.name) && !x.fileNameExceptionReason).length
    },
    validateFileNameClient(fileName) {
      if (!this.isHIAUser()) {
        return true
      }
      return fileName.toUpperCase().includes(this.currentClient.toUpperCase())
    },
    hasFileNameException() {
      if (this.filesToOperateOn.some(x => !this.validateFileNameClient(x.name))) {
        return true
      }
      return false
    },
    disableConfirm() {
      if (this.filesToOperateOn.some(x => !this.validateFileNameClient(x.name) && !x.fileNameExceptionReason)) {
        return true
      }
      return false
    },
    setFileBreadCrumbs(directoryNavigation) {
      let arr = directoryNavigation.split('/')
      let breadCrumbs = []
      let path = '/'
      for (let i = 1; i < arr.length - 1; i++) {
        path += arr[i] + '/'
        breadCrumbs.push({
          to: { path: `/${this.currentClientId}/documents/#${path}` },
          label: decodeURIComponent(arr[i])
        })
      }
      this.fileBreadCrumbs = breadCrumbs
    },
    navigateToFolder(directory) {
      let newDirectory = `${this.parentDirectoryNavigation}${encodeURIComponent(directory)}/`
      this.setFileBreadCrumbs(newDirectory)
      this.filterCriteria = ''
      this.$router.push(`/${this.currentClientId}/documents/#${newDirectory}`)
    },
    getDownloadLink(id) {
      var newWindow = window.open('', '_blank')
      this.GET_DOWNLOAD_LINK(id).then(response => {
        newWindow.location.href = `${process.env.VUE_APP_API_BASE_URL}${response.data.tempLink}`
      })
    },
    openUploadDialog() {
      document.getElementById('fileUpload').click()
    },
    openDownloadDialog(selectedRows) {
      let parts = this.parentDirectoryNavigation.split('/')
      let fileName = ''
      if (parts.length > 2) {
        fileName = parts[parts.length - 2] + '.zip'
      } else {
        fileName = this.currentClient + '.zip'
      }
      this.fileOperationsDialogTitle = 'Download Files'
      this.fileOperationsDialogVisible = true
      this.filesToOperateOn = [
        {
          name: fileName,
          loadingStatus: 'loading',
          statusMessage: 'zipping files...',
          percentCompleted: 0,
          onDownloadProgress: {},
          progressStatus: 'text',
          progressColor: '#7CBE5F'
        }
      ]

      let totalZipSize = selectedRows.reduce((total, y) => total + y.size, 0)

      // let timerId = setInterval(() => {
      //   this.filesToOperateOn[0].percentCompleted++
      //   if (this.filesToOperateOn[0].percentCompleted === 79) {
      //     this.filesToOperateOn[0].statusMessage = 'almost done...'
      //     clearInterval(timerId)
      //   }
      // }, 800)

      this.filesToOperateOn[0].onDownloadProgress = progressEvent => {
        this.filesToOperateOn[0].percentCompleted = Math.round((progressEvent.loaded * 100) / totalZipSize)

        if (this.filesToOperateOn[0].percentCompleted >= 95) {
          // clearInterval(timerId)
          this.filesToOperateOn[0].percentCompleted = 95
          this.filesToOperateOn[0].statusMessage = 'almost done...'
        }
      }

      let payload = {
        documents: selectedRows,
        displayDirectory: fileName,
        currentDirectory: this.parentDirectoryNavigation,
        onDownloadProgress: this.filesToOperateOn[0].onDownloadProgress
      }

      // this.DOWNLOAD_MULTIPLE(payload).then((response) => {
      //   this.filesToOperateOn = [{ name: fileName, loadingStatus: 'done', statusMessage: 'done', progressStatus: 'success', percentCompleted: 100 }]
      //   // clearInterval(timerId)

      //   let blob = new Blob([response.data], { type: 'application/octet-stream' })
      //   this.zipFile.fileUrl = blob
      //   this.zipFile.fileName = fileName

      //   if (window.navigator.msSaveOrOpenBlob) {
      //     // Internet Explorer
      //     window.navigator.msSaveOrOpenBlob(blob, fileName)
      //   } else {
      //     var el = document.getElementById('hiddenAnchor')
      //     el.href = window.URL.createObjectURL(blob)
      //     el.download = fileName
      //     el.click()
      //     // this.downloadData('Archive.zip', response.data)
      //   }
      // }, error => {
      //   this.filesToOperateOn = [{ name: fileName, loadingStatus: 'error', statusMessage: error, progressStatus: 'exception', percentCompleted: 100, progressColor: '#FF3232' }]
      // })

      this.POST_ZIPBUILDER(payload).then(
        response => {
          this.filesToOperateOn = [
            {
              name: fileName,
              loadingStatus: 'done',
              statusMessage: 'done',
              progressStatus: 'success',
              percentCompleted: 100
            }
          ]
          // build link to click
          this.generateDownloadLink(response.data)
          this.fileOperationsDialogVisible = false
        },
        error => {
          this.filesToOperateOn = [
            {
              name: fileName,
              loadingStatus: 'error',
              statusMessage: error,
              progressStatus: 'exception',
              percentCompleted: 100,
              progressColor: '#FF3232'
            }
          ]
        }
      )
    },
    postFilesRecursive(filesToUpload, i) {
      return new Promise(resolve => {
        filesToUpload[i].loadingStatus = 'loading'
        filesToUpload[i].statusMessage = 'uploading...'

        filesToUpload[i].onUploadProgress = progressEvent => {
          filesToUpload[i].percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          if (filesToUpload[i].percentCompleted >= 90) {
            filesToUpload[i].percentCompleted = 90
            filesToUpload[i].statusMessage = 'almost done...'
          }
        }

        this.POST_DOCUMENT(filesToUpload[i]).then(
          () => {
            filesToUpload[i].loadingStatus = 'done'
            filesToUpload[i].statusMessage = 'done'
            filesToUpload[i].progressStatus = 'success'
            filesToUpload[i].percentCompleted = 100

            if (i === filesToUpload.length - 1) {
              this.loading = false
              resolve()
            } else {
              resolve(this.postFilesRecursive(filesToUpload, i + 1))
            }
          },
          error => {
            filesToUpload[i].loadingStatus = 'error'
            filesToUpload[i].progressStatus = 'exception'
            filesToUpload[i].progressColor = '#FF3232'
            filesToUpload[i].percentCompleted = 100

            if (error.response) {
              filesToUpload[i].statusMessage = error.response.data.message
            }

            if (i === filesToUpload.length - 1) {
              this.loading = false
              resolve()
            } else {
              resolve(this.postFilesRecursive(filesToUpload, i + 1))
            }
          }
        )
      })
    },
    handleFileUpload(e) {
      this.filesToOperateOn = []
      let tempFiles = e.target.files
      const totalCount = tempFiles.length
      if (totalCount > 0) {
        for (let i = 0; i < totalCount; i++) {
          this.filesToOperateOn.push({
            attachment: tempFiles[i],
            name: tempFiles[i].name,
            directory: this.parentDirectoryNavigation,
            statusMessage: '',
            loadingStatus: '',
            percentCompleted: 0,
            onUploadProgress: {},
            progressStatus: 'text',
            progressColor: '#7CBE5F',
            fileNameExceptionReason: null
          })
        }

        this.fileOperationsDialogTitle = 'Upload Details'
        this.fileOperationsConfirmMessage = `Choose Confirm to upload ${totalCount} ${totalCount === 1 ? 'file' : 'files'} to ${this.currentClientName} (${this.currentClient})`
        this.fileOperationsDialogVisible = true
      }
    },
    startFileUpload() {
      this.loading = true
      this.fileOpeartionConfirmed = true
      this.postFilesRecursive(this.filesToOperateOn, 0).then(() => {
        let payload = {
          clientNumber: this.currentClient,
          docPath: this.parentDirectoryNavigation,
          documents: this.filesToOperateOn.filter(x => x.statusMessage === 'done').map(y => y.name)
        }
        this.POST_DOCUPLOADALERT(payload)
      })
    },
    deleteRecursive(itemsToDelete, i) {
      itemsToDelete[i].loadingStatus = 'loading'
      itemsToDelete[i].statusMessage = 'deleting...'

      let timerId = setInterval(() => {
        itemsToDelete[i].percentCompleted++
        if (itemsToDelete[i].percentCompleted === 79) {
          itemsToDelete[i].statusMessage = 'almost done...'
          clearInterval(timerId)
        }
      }, 800)

      itemsToDelete[i].onDownloadProgress = progressEvent => {
        if (!itemsToDelete[0].percentCompleted > Math.round((progressEvent.loaded * 100) / progressEvent.total)) {
          itemsToDelete[i].percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        }

        if (itemsToDelete[i].percentCompleted >= 80) {
          clearInterval(timerId)
          itemsToDelete[i].percentCompleted = 80
          itemsToDelete[i].statusMessage = 'almost done...'
        }
      }

      if (i === 0) {
        this.fileOperationsDialogTitle = 'Delete Details'
        this.fileOperationsDialogVisible = true
      }

      this.DELETE_DOCUMENT(itemsToDelete[i]).then(
        () => {
          itemsToDelete[i].loadingStatus = 'done'
          itemsToDelete[i].statusMessage = 'done'
          itemsToDelete[i].progressStatus = 'success'
          itemsToDelete[i].percentCompleted = 100
          clearInterval(timerId)

          if (i === itemsToDelete.length - 1) {
            this.loading = false
            this.selectedRows = []
          } else {
            this.deleteRecursive(itemsToDelete, i + 1)
          }
        },
        error => {
          itemsToDelete[i].loadingStatus = 'error'
          itemsToDelete[i].progressStatus = 'exception'
          itemsToDelete[i].progressColor = '#FF3232'
          itemsToDelete[i].percentCompleted = 100
          clearInterval(timerId)

          if (error.response) {
            itemsToDelete[i].statusMessage = error.response.data.message
          }

          if (i === itemsToDelete.length - 1) {
            this.loading = false
          } else {
            this.deleteRecursive(itemsToDelete, i + 1)
          }
        }
      )
    },
    openMoveDialog(copy = false) {
      this.copyFiles = copy
      let title = copy ? 'Copy' : 'Move'
      this.setMoveToBreadcrumbs(this.parentDirectoryNavigation)
      this.moveMessage = this.selectedRows.length === 1 ? `${title} 1 file to...` : `${title} ${this.selectedRows.length} files to...`
      this.moveDialogVisible = true
      this.moveDialogLoading = true
      this.GET_SUBDIRECTORIES(this.parentDirectoryNavigation).then(() => {
        this.moveDialogLoading = false
      })
    },
    moveActionDrilldown(drillToObject, forceUpdate) {
      this.moveToDirectory = drillToObject
      let fullPath = drillToObject.directory + drillToObject.name + '/'
      this.setMoveToBreadcrumbs(fullPath)
      if (drillToObject.hasSubdirectories || forceUpdate) {
        this.moveDialogLoading = true
        this.GET_SUBDIRECTORIES(drillToObject.directory + drillToObject.name + '/').then(() => {
          this.moveDialogLoading = false
        })
      }
    },
    moveRecursive(itemsToMove, i, moveToDirectory) {
      let status = this.copyFiles ? 'copying...' : 'moving...'
      let dialogTitle = this.copyFiles ? 'Copy Details' : 'Move Details'
      let methodName = this.copyFiles ? 'COPY_DOCUMENT' : 'MOVE_DOCUMENT'
      itemsToMove[i].loadingStatus = 'loading'
      itemsToMove[i].statusMessage = status

      itemsToMove[i].onUploadProgress = progressEvent => {
        itemsToMove[i].percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        if (itemsToMove[i].percentCompleted >= 90) {
          itemsToMove[i].percentCompleted = 90
          itemsToMove[i].statusMessage = 'almost done...'
        }
      }

      if (i === 0) {
        this.fileOperationsDialogTitle = dialogTitle
        this.fileOperationsDialogVisible = true
        this.$nextTick(() => {
          this.moveDialogVisible = false
        })
      }
      console.log(methodName, this.copyFiles)
      this[methodName](itemsToMove[i]).then(
        () => {
          itemsToMove[i].loadingStatus = 'done'
          itemsToMove[i].statusMessage = 'done'
          itemsToMove[i].progressStatus = 'success'
          itemsToMove[i].percentCompleted = 100

          if (i === itemsToMove.length - 1) {
            this.loading = false
            this.selectedRows = []
          } else {
            this.moveRecursive(itemsToMove, i + 1)
          }
        },
        error => {
          itemsToMove[i].loadingStatus = 'error'
          itemsToMove[i].progressStatus = 'exception'
          itemsToMove[i].progressColor = '#FF3232'
          itemsToMove[i].percentCompleted = 100
          if (error.response) {
            itemsToMove[i].statusMessage = error.response.data.message
          }

          if (i === itemsToMove.length - 1) {
            this.loading = false
          } else {
            this.moveRecursive(itemsToMove, i + 1)
          }
        }
      )
    },
    moveSelected() {
      this.filesToOperateOn = []
      for (let i = 0; i < this.selectedRows.length; i++) {
        // set the new directory
        this.selectedRows[i].directory = this.moveToDirectory.directory + this.moveToDirectory.name + '/'
        // object.assign lets us add a couple of reactive properties to the document object so that we can update status while loading
        this.filesToOperateOn.push(
          Object.assign(
            {
              statusMessage: '',
              loadingStatus: '',
              percentCompleted: 0,
              onUploadProgress: {},
              progressStatus: 'text',
              progressColor: '#7CBE5F'
            },
            this.selectedRows[i]
          )
        )
      }
      this.moveRecursive(this.filesToOperateOn, 0, this.moveToDirectory)
    },
    setMoveToBreadcrumbs(directoryNavigation) {
      let arr = directoryNavigation.split('/')
      let breadCrumbs = []
      let path = ''
      for (let i = 1; i < arr.length - 1; i++) {
        path += arr[i - 1] + '/'
        breadCrumbs.push({
          directory: decodeURIComponent(path),
          name: decodeURIComponent(arr[i])
        })
      }
      this.moveToBreadcrumbs = breadCrumbs
    },
    isMoveDisabled() {
      if (!this.moveToDirectory) {
        return true
      }
      return this.parentDirectoryNavigation === this.moveToDirectory.directory + this.moveToDirectory.name + '/'
    },
    deleteSelected() {
      let message = ''
      if (this.selectedRows.length > 1) {
        message = `Are you sure you want to delete ${this.selectedRows.length} items?`
      } else if (this.selectedRows.length === 1) {
        message = `Are you sure you want to delete ${this.selectedRows[0].name}?`
      }

      this.$confirm(message, 'Delete items', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.filesToOperateOn = []
          // copy into a reactive array with some additional properties
          for (let i = 0; i < this.selectedRows.length; i++) {
            this.filesToOperateOn.push({
              name: this.selectedRows[i].name,
              id: this.selectedRows[i].id,
              statusMessage: '',
              loadingStatus: '',
              percentCompleted: 0,
              onDownloadProgress: {},
              progressStatus: 'text',
              progressColor: '#7CBE5F'
            })
          }

          this.loading = true
          this.deleteRecursive(this.filesToOperateOn, 0)
        })
        .catch(() => {})
    },
    closeMoveDialog() {
      this.moveToDirectory = null
      this.moveDialogVisible = false
    },
    closeNewFolderDialog() {
      this.newFolderDialogVisible = false
      this.newFolderName = ''
    },
    closeFileOperationsDialog() {
      this.fileOperationsDialogVisible = false
    },
    handleFileOperationsDialogClosed() {
      this.fileOperationsDialogTitle = ''
      this.fileOperationsConfirmMessage = ''
      this.fileOpeartionConfirmed = false
      this.filesToOperateOn = []
      this.massUpdateFileReason = null
      const input = document.getElementById('fileUpload')
      if (input) {
        input.value = null
      }
    },
    createNewFolder() {
      if (!this.newFolderName) {
        return
      }

      let payload = {
        name: this.newFolderName,
        directory: decodeURIComponent(this.parentDirectoryNavigation),
        clientNumber: this.currentClient
      }

      this.POST_FOLDER(payload).then(
        () => {
          this.navigateToFolder(this.newFolderName)
          this.newFolderName = null
          this.newFolderDialogVisible = false
        },
        error => {
          this.showErrorMessage(error)
          console.log(error)
          this.newFolderDialogVisible = false
        }
      )
    },
    invalidFolderMessage() {
      if (this.newFolderName) {
        if (/[\\/:*?""<>|.]/.test(this.newFolderName)) {
          return `Folder name may not contain any of \\ / : * ? "< > | .`
        }
        if (!/^(?!\s).+(?<!\s)$/gm.test(this.newFolderName)) {
          // /^(?!\s).+(?<!\s)$/gm   /^\S+(?: \S+)*$/
          return `Folder name may not contain blank space at the beginning or end`
        }
      }

      return ''
    },
    formatDate(sourceDate) {
      if (sourceDate && isNaN(sourceDate)) {
        return format(parseISO(sourceDate), 'M/d/yyyy hh:mm a')
      }
      return ''
    },
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    putEditFileFolderName(row) {
      // revert back to normal; make put if different
      this.showFileFolderNameInput = 0
      let tempName
      let ext

      // trim blank space
      if (this.newFileFolderName) {
        this.newFileFolderName = this.newFileFolderName.trim()
      }

      if (!row.isFolder) {
        let lastIndex = row.name.lastIndexOf('.')
        tempName = row.name.substring(0, lastIndex)
        // get ext if file and add it
        ext = row.name.substring(lastIndex, row.name.length)
      } else {
        tempName = row.name
        ext = ''
      }

      if (tempName !== this.newFileFolderName && this.newFileFolderName.length) {
        if (/[\\/:*?""<>|.]/.test(this.newFileFolderName) && row.isFolder) {
          Message({
            message: `Folder name may not contain any of \\ / : * ? "< > | .`,
            type: 'error'
          })
          this.newFileFolderName = ''
          return false
        }

        // build payload; call put
        let payload = {
          clientNumber: this.currentClient,
          docPath: this.parentDirectoryNavigation,
          id: row.id,
          newName: this.newFileFolderName,
          ext: ext
        }
        this.PUT_RENAMEDOCUMENT(payload).then(
          response => {
            this.showSuccessMessage('Rename Successful')
          },
          error => {
            this.showErrorMessage(error)
          }
        )
      }
      // reset
      this.newFileFolderName = ''
    },
    editFileFolderName(index, row) {
      // hide name; show input; focus input; local variable to current name; remove ext if file
      this.showFileFolderNameInput = row.id
      this.$nextTick(() => {
        let input = document.querySelector('.documentTableInput_' + row.id)
        input.querySelector('input').focus()
        // set local variable to current name; remove ext if file
        if (!row.isFolder) {
          let lastIndex = row.name.lastIndexOf('.')
          this.newFileFolderName = row.name.substring(0, lastIndex)
        } else {
          this.newFileFolderName = row.name
        }
      })
    },
    actionMenuCommands(object) {
      if (object.action === 'download' && !object.scope.row.isFolder) {
        this.getDownloadLink(object.scope.row.id)
      }

      if (object.action === 'download' && object.scope.row.isFolder) {
        this.openDownloadDialog([object.scope.row])
      }

      if (object.action === 'move') {
        this.$refs.documentTable.clearSelection()
        this.$refs.documentTable.toggleRowSelection(object.scope.row)
        this.openMoveDialog(false)
      }
      if (object.action === 'copy') {
        this.$refs.documentTable.clearSelection()
        this.$refs.documentTable.toggleRowSelection(object.scope.row)
        this.openMoveDialog(true)
      }
      if (object.action === 'delete') {
        this.$refs.documentTable.clearSelection()
        this.$refs.documentTable.toggleRowSelection(object.scope.row)
        this.deleteSelected()
      }
      if (object.action === 'rename') {
        this.editFileFolderName(object.scope.$index, object.scope.row)
      }
    },
    handleExtensionIcon(fileName) {
      let ext = /[.]/.exec(fileName) ? /[^.]+$/.exec(fileName)[0].toLowerCase() : undefined
      let icon = 'file'
      if (this.fileAccept.some(x => x.ext === ext)) {
        icon = this.fileAccept.filter(x => x.ext === ext).map(y => y.icon)[0]
      } else {
        icon = 'mdi-file-document-box-outline'
      }
      return icon
    },
    documentTableStats() {
      let data = this.filteredDocuments
      if (data.filter(f => f.isFolder).length > 0) {
        return `${data.filter(f => f.isFolder).length} Directories and ${data.filter(f => !f.isFolder).length} Documents`
      } else {
        return `${data.filter(f => !f.isFolder).length} Documents`
      }
    },
    generateDownloadLink(href) {
      let link = document.createElement('a')
      link.setAttribute('style', 'display: hidden;')
      link.setAttribute('download', 'download')
      link.id = 'hiddenLink'
      link.href = `${process.env.VUE_APP_API_BASE_URL}${href}`
      document.getElementsByTagName('body')[0].appendChild(link)
      document.getElementById('hiddenLink').click()
      // remove link
      let timerId = setInterval(() => {
        document.getElementById('hiddenLink').remove()
        clearInterval(timerId)
      }, 500)
    },
    openMoveParticleDialog() {
      let payload = {
        selectedRows: this.selectedRows,
        moveMessage: this.selectedRows.length === 1 ? 'Move 1 file to...' : `Move ${this.selectedRows.length} files to...`
      }
      this.$refs.onedriveListChild.openMoveDialogParticle(payload)
    }
  },
  created: function() {
    this.initialize()
  },
  mounted: function() {
    if (!this.nucleusUser()) {
      return
    }
    this.itemId = this.clients.find(x => x.clientNumber === this.currentClient).linkedItemId
    this.oneDriveWait = true
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientName', 'currentClientId', 'clients', 'user']),
    ...mapState('documents/', ['documents', 'moveActionSubdirectories', 'fileAccept']),
    filteredDocuments() {
      if (this.documents.length) {
        return this.filterList(this.documents, this.filterCriteria, ['creatorName', 'directory', 'name', 'created'])
      }
      return []
    }
  },
  watch: {
    $route() {
      this.initialize()
    }
  }
}
</script>

<style scoped>
>>> .dot {
  height: 18px;
  width: 18px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  color: rgba(255, 255, 255, 0.897);
  margin: 0px 15px 0px 5px;
}

>>> .document-item .item:hover {
  color: rgb(109, 207, 246);
  width: 100%;
  cursor: pointer;
}

>>> .document-item-selected .item {
  color: rgb(109, 207, 246);
  width: 100%;
  cursor: pointer;
  background-color: #f5f7fa;
}

>>> .cell {
  word-break: normal !important;
}

#documentTable >>> tr > td:first-child .cell,
#documentTable >>> tr > th:first-child .cell {
  text-overflow: clip;
}

#documentTable {
  /* max-height: 55vh;
    overflow-y: auto; */
  width: 100%;
  margin-top: 20px;
}

#documentTable::before {
  height: 0px !important;
}

#documentTable >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  /*background-color: #1c3c5f;
    border-color: #1c3c5f; */
}

#documentTable >>> input.el-input__inner {
  height: 25px !important;
}

#documentTable >>> .el-checkbox__inner {
  border-radius: 10px;
}

>>> .documentActionMenuIcon {
  margin: 0px 5px 0px 0px;
}

>>> .ellipsesIcon {
  font-size: 18px;
  color: #606266;
  float: left;
  margin: 3px 0px 0px 0px;
  padding: 0px 3px 0px 3px;
  border: 1px solid transparent;
  border-radius: 100px;
  cursor: pointer;
}

>>> .ellipsesIcon:hover {
  font-size: 18px;
  color: #1c3c5f;
  float: left;
  margin: 3px 0px 0px 0px;
  padding: 0px 3px 0px 3px;
  border: 1px solid #1c3c5f;
  border-radius: 100px;
  cursor: pointer;
}

>>> .showDocItem {
  display: block;
}

>>> .hideDocItem {
  display: none;
}

/* ICON CLASSES */
>>> .folderIcon {
  font-size: 36px;
  /* color: #f9e4b7; */
  color: #fadfad;
  float: left;
  margin: 2px 0px 0px 0px;
  padding: 0px 5px 0px 0px;
}

>>> .docName {
  float: left;
  margin: 3px 0px 0px 0px;
}

>>> .docIcon {
  font-size: 30px;
  color: rgba(0, 86, 149, 0.7);
  float: left;
  margin: 0px 0px 0px 0px;
  padding: 0px 11px 0px 0px;
}

.actionIcons {
  font-size: 16px;
  color: rgba(0, 86, 149, 0.7);
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
}

>>> .mdi-file-document-box-outline {
  color: #547b93;
}

>>> .mdi-image {
  color: #03284d;
}

>>> .mdi-file-pdf-box {
  color: #ff0021;
}

>>> .mdi-file-word-box {
  color: #2d5794;
}

>>> .mdi-file-excel-box {
  color: #2e7048;
}

>>> .mdi-file-cabinet {
  color: #7c4379;
}

>>> .mdi-outlook {
  color: #0070c0;
}

/* ACTION MENU */

.actionButtonsIcon {
  font-size: 18px;
}

.actionButtons li {
  margin: 5px 0px 5px 0px;
  cursor: pointer;
}

.actionButtons li:first-child {
  margin: 0px 0px 5px 0px;
}

.actionButtonsItem:hover {
  background: #005695;
  padding: 4px 5px 4px 5px;
  width: 150px;
  border-radius: 30px;
  color: #ffffff;
  font-weight: normal;
}

.actionButtonsItemActive {
  background: #005695;
  padding: 4px 5px 4px 5px;
  width: 150px;
  text-align: center;
  border-radius: 30px;
  color: #ffffff;
  font-weight: normal;
}

.actionButtonsItem {
  background: transparent;
  padding: 4px 5px 4px 5px;
  width: 150px;
  border-radius: 30px;
  color: #005695;
  font-weight: normal;
}

.actionButtonsItem span {
  margin-left: 20px;
}

/* DOCUMENT TABLE STATS */
#documentTableStats {
  padding: 0px 0px 0px 0px;
  margin: 7px 0px 0px 15px;
}

#documentTableStats p {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  font-size: 12px;
  font-weight: normal;
  color: #606266;
}

/* FILE OPERATION DIALOG */
#fileOperationDialogTable >>> .el-progress__text {
  font-size: 11px !important;
}

#fileOperationDialogTable >>> .is-exception > div > .el-icon-close {
  font-size: 20px;
}

#fileOperationDialogTable >>> .is-success > div > .el-icon-check {
  font-size: 20px;
}

/* IE specific */
.ieGridFix {
  display: -ms-grid;
  -ms-grid-columns: 36px 90%;
}

.ieGridColumnFix {
  -ms-grid-column: 2;
}

.itemDisabled {
  cursor: default !important;
}

.itemDisabled div {
  pointer-events: none;
  opacity: 0.6;
}
</style>
